import React from 'react';
import './Spinner.css';
const Spinner=(props)=>(
<div className={"Loader"}>Loading...</div>
);

export default Spinner;


// WEBPACK FOOTER //
// ./src/Components/UI/Spinner/Spinner.js